<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Admin Dashboard</h5>
				</b-col>				
			</b-row>-->
		
		
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<!-- <h3 class="text-left">Manage Seller</h3> -->
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!--<b-button variant="dark" pill class="mr-2" @click="redirectUrl('/user-roles')" v-if="$root.chkperm('userroles','enabled')">Manage Roles</b-button> -->
					<download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsCsv" name="seller_list.csv" size="sm"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export CSV</download-csv>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<!-- <template v-slot:thead-top="">
										<b-tr>
											<b-th colspan="6"></b-th>
											<b-th variant="secondary" colspan="5" class="text-center">Monthly Information</b-th>
											<b-th colspan="2"></b-th>
										</b-tr>
									</template> -->
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(rating)="row">
										<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="info"></b-form-rating>
									</template>
									<template v-slot:cell(actions)="row">
									
										<b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('users','edit')" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										
										<b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('users','edit')" class="mr-1" @click="showViewModal(row.item, row.index, $event.target)" size="sm">VIEW</b-button>
										
										
										
										 <b-button variant="primary" pill  @click="triggerimportcsv(row.item.id)">Import Product</b-button>
										<b-form-file type="file" class="importfile" style="display:none" v-model="product_csv" accept=".csv" @change="uploadfile($event)"></b-form-file>
										&nbsp;
										
										<whatappchat-user :phone="row.item.phone" :whatsapp="row.item.whatsapp" :userId="row.item.id" listtype="user"></whatappchat-user>
										
										<!--b-button pill variant="danger" v-if="row.item.role!=1 && $root.chkperm('users','delete')" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
				<b-modal id="my-modal" :title="(selectedItem.id > 0)?'Edit User':'Add User'" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
					<form ref="form" @submit.stop.prevent="handleSubmit">
						<b-form-group label="Username" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Username is required">
							<b-form-input v-model="selectedItem.username" required></b-form-input>
						</b-form-group>
						<b-form-group label="Email" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
							<b-form-input v-model="selectedItem.email" required></b-form-input>
						</b-form-group>
						<b-form-group label="Roles" label-for="fp-input" label-cols="3" label-size="sm" label-align-sm="right">
							<b-form-select v-model="selectedItem.role" :options="user_roles" required></b-form-select>
						</b-form-group>
						<b-form-group label="Password" label-cols="3" label-size="sm" label-align-sm="right">
							<b-form-input v-model="selectedItem.password"></b-form-input>
						</b-form-group>
						<b-form-group label="Rating" label-cols="3" label-size="sm" label-align-sm="right">
							<b-form-input v-model="selectedItem.rating" required></b-form-input>
						</b-form-group>
						<b-form-group label="Secure Code" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
							<b-form-input v-model="selectedItem.secure_code" required></b-form-input>
						</b-form-group>
						<b-form-group label="Status" label-for="status" label-cols="3" label-size="sm" label-align-sm="right">
							<b-form-select v-model="selectedItem.status" :options="$root.status_options" required></b-form-select>
						</b-form-group>
					</form>
					<template v-slot:modal-footer="{ ok, close }">
						<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
						<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
					</template>
				</b-modal>
				
				<b-modal id="viewProfile" title="Seller Profile" size="xl">
							<b-row class="mb-1">
								<b-col lg="4" md="12" sm="12">
									<b-table-simple hover small caption-top responsive>
										<!--<caption></caption>-->
										<b-thead head-variant="light">
											<b-tr>
												<b-th colspan="2">Account Details</b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr>
												<b-th>Name</b-th>
												<b-th class="text-right">{{accountDetails.username}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Email</b-th>
												<b-th class="text-right">{{accountDetails.email}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Phone</b-th>
												<b-th class="text-right">{{accountDetails.phone}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>City</b-th>
												<b-th class="text-right">{{accountDetails.city}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>State</b-th>
												<b-th class="text-right">{{accountDetails.state}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Postcode</b-th>
												<b-th class="text-right">{{accountDetails.pincode}}</b-th>
											</b-tr>
									   </b-tbody>
	
									</b-table-simple>
									
								</b-col>
								<b-col lg="4" md="12" sm="12">
										<b-table-simple hover small caption-top responsive>
											<!--<caption></caption>-->
											<b-thead head-variant="light">
												<b-tr>
													<b-th colspan="2">Business Details</b-th>
												</b-tr>
											</b-thead>
											<b-tbody>
												<b-tr>
													<b-th>Company/Business Name</b-th>
													
													<b-th class="text-right">{{businessDetails.b_business_name}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>PAN Number</b-th>
													<b-th class="text-right">{{businessDetails.b_pan}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>GST Number</b-th>
													<b-th class="text-right">{{businessDetails.b_gst}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>Office Address</b-th>
													<b-th class="text-right">{{businessDetails.b_office_address}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>Communication Address</b-th>
													<b-th class="text-right">{{businessDetails.b_communication_address}}</b-th>
												</b-tr>
												
										   </b-tbody>
									
										</b-table-simple>
								</b-col>
								<b-col lg="4" md="12" sm="12" >
										<b-table-simple hover small caption-top responsive>
											<!--<caption></caption>-->
											<b-thead head-variant="light">
												<b-tr>
													<b-th colspan="2">Payment Details</b-th>
												</b-tr>
											</b-thead>
											<b-tbody>
												<b-tr>
													<b-tabs content-class="mt-3" small>
														 <b-tab title="Bank Details" >
															<b-table-simple  small caption-top responsive>
															
																<b-thead head-variant="light">
																	<b-tr>
																		<b-th >Account No</b-th>
																		<b-th >Action</b-th>
																	</b-tr>
																</b-thead>
																<b-tbody>
																	<b-tr v-for="bankRor in bankDetails" :key="bankRor.id">
																		<b-th>{{bankRor.account}}</b-th>
																		<b-th ><b-link @click="showMyaccount(bankRor,$event.target)"><i class="fa fa-eye" aria-hidden="true"></i></b-link></b-th>
																	</b-tr>
																	
																	
															   </b-tbody>
							
															</b-table-simple>
														 
														 
														 
														 </b-tab>
														<b-tab title="Wallet Details">
															<b-table-simple  small caption-top responsive>
																<!--<caption></caption>-->
																
																
																
																<b-thead head-variant="light">
																	<b-tr>
																		<b-th >	Phone Number</b-th>
																		<b-th >Action</b-th>
																	</b-tr>
																</b-thead>
																<b-tbody>
																	<b-tr  v-for="walletRor in walletDetails" :key="walletRor.id">
																		<b-th>{{walletRor.phone}}</b-th>
																		<b-th ><b-link @click="showMywallet(walletRor,$event.target)"><i class="fa fa-eye" aria-hidden="true"></i></b-link></b-th>
																	</b-tr>
															   </b-tbody>
															</b-table-simple>
														</b-tab>
													</b-tabs>	
												</b-tr>
										   </b-tbody>
										</b-table-simple>
								</b-col>
							</b-row>
						<b-row class="px-2">
						
						<b-col class="px-2" lg="2" md="6" sm="6">
							<b-card class="mb-3">						
								<b-card-text>
									<small>Total Products: </small>{{productSeller.totalProduct || 0 }}
								</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="2" md="6" sm="6">
							<b-card class="mb-3">
								<b-card-text><small>Active Orders:</small> {{orderDetails.totalOrders || 0 }}
								</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="2" md="6" sm="6" >
							<b-card class=" mb-3">
								<b-card-text><small>Total Sales</small> {{$root.currency()}} {{$root.tofixed(orderDetails.totalOrder_amount ||0, 2)}}</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="2" md="6" sm="6" >
							<b-card class="mb-3">
								<b-card-text> <small>Canceled orders: </small>  {{orderCancelled.totalCancelled || 0 }}</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="2" md="6" sm="6">
							<b-card class="mb-3">
								<b-card-text> <small>Returned orders: </small> {{orderRefunded.totalRefunded || 0}}</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="2" md="6" sm="6">
							<b-card class="mb-3">
								<b-card-text> <small>Fulfillment: </small> {{orderFulfillment.totalFulfillment || 0 }}</b-card-text>
							</b-card>
						</b-col>
					</b-row>
					<b-row class="px-2">
						
						<b-col class="px-2" lg="2" sm="6">
							<b-card class="mb-3">						
								<b-card-text>
									<small>Total Login Count: </small> {{loginCount.totalLoginTime || 0}}
								</b-card-text>
							</b-card>
						</b-col>
						<b-col class="px-2" lg="3" sm="6">
							<b-card class="mb-3">
								<b-card-text><small>Last Login :</small> {{loginTime.lastLoginTime!=''?$moment(loginTime.lastLoginTime).format('DD-MM-YYYY HH:mm:ss'): '---' }} 
								</b-card-text>
							</b-card>
						</b-col>
						
					</b-row>
					
					<b-row class="px-2">
						
						<b-col class="px-2" >
							<h5> Seller Agreement<br/>
								<small>(To be signed by Alluraa and the Brand/Seller)</small>
								</h5>
							<b-card>
							<admin-kyc-verification :businessData="businessDetails" ></admin-kyc-verification>
							</b-card>
						</b-col>
						
						
					</b-row>
					<template v-slot:modal-footer="{ ok, close }">
						<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
						
						<b-button size="sm ml-3 mr-2" variant="success" @click="sendBulkemail(1)">Update Profile Email</b-button>
						
					</template>
				</b-modal>

					<!--bankAccountDetails:[],
					bankwalletDetails:[],-->
				
						<b-modal id="viewAccountdetails" title="Bank Account Details" size="sm" hide-footer>
							<b-row class="mb-1">
								<b-col lg="12" md="12" sm="12">
									<b-table-simple hover small caption-top responsive>
										<!--<caption></caption>-->
										<!--<b-thead head-variant="light">
											<b-tr>
												<b-th colspan="2">Account Details</b-th>
											</b-tr>
										</b-thead>-->
										<b-tbody>
											<b-tr>
												<b-th>Beneficiary Name</b-th>
												<b-th class="text-right">{{bankAccountDetails.beneficiary}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Bank Name</b-th>
												<b-th class="text-right">{{bankAccountDetails.bank_name}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Account Number</b-th>
												<b-th class="text-right">{{bankAccountDetails.account}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>IFSC Code</b-th>
												<b-th class="text-right">{{bankAccountDetails.ifsc}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Account Type</b-th>
												<b-th class="text-right">{{bankAccountDetails.account_type}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Status</b-th>
												<b-th class="text-right">
												<b-badge pill variant="danger" v-if="bankAccountDetails.status == 0">INACTIVE</b-badge>
												<b-badge pill variant="success" v-else>ACTIVE</b-badge>
												</b-th>
											</b-tr>
									   </b-tbody>
									</b-table-simple>
								</b-col>
							</b-row>
				</b-modal>
				<b-modal id="viewWalletdetails" title="Wallet Details" size="sm" hide-footer>
					<b-row class="mb-1">
						<b-col lg="12" md="12" sm="12">
							<b-table-simple hover small caption-top responsive>
								<!--<caption></caption>-->
								<!--<b-thead head-variant="light">
									<b-tr>
										<b-th colspan="2">Account Details</b-th>
									</b-tr>
								</b-thead>-->
								<b-tbody>
									<b-tr>
										<b-th>Beneficiary Name</b-th>
										<b-th class="text-right">{{bankwalletDetails.beneficiary}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Phone Number</b-th>
										<b-th class="text-right">{{bankwalletDetails.phone}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Wallet Name</b-th>
										<b-th class="text-right">{{bankwalletDetails.wallet_name}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Status</b-th>
										<b-th class="text-right">
										<b-badge pill variant="danger" v-if="bankwalletDetails.status == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
										
										
										</b-th>
									</b-tr>
									
							   </b-tbody>
							</b-table-simple>
						</b-col>
					</b-row>
			</b-modal>

				
				
				
				
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import Adminkycverification from "@/components/admin-kyc-verification.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Whatappchatuser from "@/components/whatapp-chat-user.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"admin-kyc-verification": Adminkycverification,
		"whatappchat-user": Whatappchatuser,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		//var self = this;
		return{
			loading: true, 
			recordsCsv:[],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Users',
					active: true
				}
			],
			recordUrl: this.$root.WEBAPI+'secureapi/seller-record',
			updateUrl: this.$root.WEBAPI+'secureapi/seller-update',
			deleteUrl: this.$root.WEBAPI+'secureapi/seller-delete',
			recordBankUrl: this.$root.WEBAPI+'secureapi/seller-bannk',
			//recordWalletUrl: this.$root.WEBAPI+'secureapi/seller-wallet',
			sendEmailbulkUrl: this.$root.WEBAPI+'secureapi/sendEmailbulktoseller',
			insertPimportsUrl: this.$root.NEWAPIURL+'sellerapi/productcsvimportadmin',
			records: [], 
			accountDetails: [],
			businessDetails:{},
			bankDetails: [],
			walletDetails: [],
			orderDetails: [],
			orderCancelled: [],
			orderFulfillment: [],
			orderRefunded: [],
			productSeller: [],
			loginCount:{totalLoginTime:''},
			loginTime:{lastLoginTime:''},
			bankAccountDetails:[],
			bankwalletDetails:[],
			selected: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			user_roles: [],
			fields: [
				{ key: 'id', label: 'ID'},
				//{ key: 'uniq_id', label: 'Unique ID'},
				{ key: 'username', label: 'Username'},
				{ key: 'rating', label: 'Rating'},
				{ key: 'email', label: 'Email'},
				{ key: 'phone', label: 'Phone'},
				//{ key: 'secure_code', label: 'Secure Code' },
				{ key: 'total_products', label: 'Products', class:'text-right' },
				/*{ key: 'total_earning', label: 'Earning', class:'text-right' },
				{ key: 'total_orders', label: 'Orders', class:'text-right' },*/
				/*{ key: 'total_customers', label: 'Customers', class:'text-right' },
				{ key: 'total_agents', label: 'Agents', class:'text-right' },*/
				{ key: 'status', label: 'Status', class:'text-center' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class:'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: 'whatsapp',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
				username: '',
				email: '',
				role: 0,
				secure_code: '',
				password: '',
				status: 0
			},
			product_csv: null,
			userIdimport:0,
			
		};
	},
	methods: {
		redirectUrl(url){
			this.$router.push(url);
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-modal');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.selectedItem.password = '';
			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		showViewModal(item, index, button) {
			var self = this;
			self.accountDetails= item;
			//self.businessDetails= item;
			//console.log('userId:'+item.id);
			var emailData = {fullname:item.username,email:item.email};
			self.selected.push(emailData);
			
			/* --------------- bankDetails ------------- */
			var userId=item.id;
			self.axios.post(self.recordBankUrl, {
				accesskey: self.$session.get('access_key'),
				userId:userId,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);
					self.bankDetails = response.data.result.bankData;
					self.walletDetails = response.data.result.walletData;
					self.orderDetails = response.data.result.orderDetails;
					self.orderFulfillment = response.data.result.orderFulfillment;
					self.orderCancelled = response.data.result.orderCancelled;
					self.orderRefunded = response.data.result.orderRefunded;
					self.productSeller = response.data.result.productDetails;
					self.loginCount = Object.assign({}, response.data.result.loginCount);
					self.loginTime = Object.assign({}, response.data.result.loginTime);
					//self.businessDetails = response.data.result.businessDetails;
					self.businessDetails = Object.assign({}, response.data.result.businessDetails);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			
			/* -------------------- */
			
			
			
			
			
			
			self.selectedItem = Object.assign({}, item);
			self.selectedItem.password = '';
			self.$root.$emit('bv::show::modal', 'viewProfile', button)
			
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete User.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.uniq_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result.records;
					var recordsNew = response.data.result.records;
					//self.records.options = JSON.parse(self.records.options);
					self.user_roles = response.data.result.roles;
					self.loading = false;
					self.totalRows = self.records.length;
					
					
					
					self.recordsCsv=[];
					recordsNew.forEach(item => {
						var statusIs = item.status==1?'Active':'Inactive';
						var arrayCsv={'Seller Name':item.username,'Email':item.email,'Phone':item.Phone,'Total  products':item.total_products,'status':statusIs};
						self.recordsCsv.push(arrayCsv);
					});
					
					
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		sendBulkemail(emailtemp){
					var self = this;
					//.log(self.selected);
					this.$bvModal.msgBoxConfirm('Please confirm that you want to Send Email!.', {
						title: 'Please Confirm',
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: 'YES',
						cancelTitle: 'NO',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if(value == true){
							self.axios.post(self.sendEmailbulkUrl, {
								accesskey: self.$session.get('access_key'),
								user_data: self.selected,
								emailtemp: emailtemp,
								status: 1
							})
							.then(function (response) {
								if(response.data.error == 0 || response.data.error == '0'){
									self.$bvToast.toast(response.data.message, {
										title: 'Email Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'success',
										solid: true,
										appendToast: true
									});
									//self.initload();
								}else{
								
									self.$bvToast.toast(response.data.message, {
										title: 'Email Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'warning',
										solid: true,
										appendToast: true
									});
								
								}
								
							})
							.catch(function (error) {
								alert(error);
							});
						}else{
							//alert('no '+item.id);
						}
					})
					.catch(err => {
						// An error occurred
						console.log(err);
					})
				},				
			showMywallet(walletItem,button){
				var self = this;
				self.bankwalletDetails= walletItem;
				self.$root.$emit('bv::show::modal', 'viewWalletdetails', button);
			},
			showMyaccount(accountItem,button){
				var self = this;
				self.bankAccountDetails= accountItem;
				//console.log(accountItem);
				self.$root.$emit('bv::show::modal', 'viewAccountdetails', button);
			},
			/* ======= Upload  CSV Import Product ======== */
			triggerimportcsv(userId){
            //this.$refs.importfile.click();
			//console.log('MyUser:'+userId);
			this.userIdimport = userId;
            document.getElementsByClassName('importfile')[0].querySelector('input').click();
			},
			uploadfile(event){
            var self = this;
            self.loading = true;
            
			
			var importuserId = self.userIdimport;
			//console.log('user_id:'+importuserId);
            let formData = new FormData();
            formData.append('csvfile', document.getElementsByClassName('importfile')[0].querySelector('input').files[0]);
            formData.append('accesskey', this.$session.get('access_key'));
            formData.append('user_id', importuserId);

            self.axios.post(self.insertPimportsUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0') {
                            self.$bvModal.hide('my-model');
                            self.$bvToast.toast(response.data.message, {
                                    title: 'Status',
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 5000,
                                    variant: 'warning',
                                    solid: true,
                                    appendToast: true
                            });
                            self.initload();
                    }
                event.target.value = '';
            }).catch(function (error) {
                    alert(error);
            });
        },
		/* ======= ======================= */

	}
}
</script>
